exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress {\n  background: #bcbfc5;\n}\n", ""]);

// exports
